import { Tooltip } from "@chakra-ui/react";

export const StatusList = ({lang, status, labels}) => (!!status && !!labels) ? <div className={"bf-step-list"}>
  {Object.entries(status).map((item, index) =>
    <Tooltip key={`bf-step-list-${index}`} label={lang(labels[item[0]])}>
      <div className="bf-step-list-item">{lang(item[1])}</div>
    </Tooltip>
  )}
</div> : null;